export function getUTCTimezone(): string {
    const timezoneValue = -new Date().getTimezoneOffset() / 60;
    return timezoneValue >= 0 ? `UTC+${timezoneValue}` : `UTC${timezoneValue}`;
}
